module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gc-Hc-Ic-Jb.b549adf2.png";